import { Button } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const SupportButton = ({ onClick }) => {
    return (
        <Button
            variant="contained"
            startIcon={<SupportAgentIcon />}
            onClick={onClick}
            sx={{
                position: "fixed",
                bottom: 30,
                left: 10,
                borderRadius: "20px",
                px: 2,
                fontWeight: 600,
                zIndex: 1400,
                bgcolor: "#324f52", color: "#fff", "&:hover": { bgcolor: "#64969d", color: "#fff" }
            }}
        >
            SUPPORT
        </Button>
    );
};

export default SupportButton;